import { AxiosResponse } from 'axios';
import { useAxios } from '@/features/common/helpers/axios';
import { AdvisorNotifications } from '@/features/shipment/types';

const { axiosService } = useAxios();

export const shipmentAdvisorNotificationStatus = async (): Promise<AdvisorNotifications | null> => {
  try {
    const response: AxiosResponse = await axiosService.get('/advisor/create-shipment');
    return response.data;
  } catch {
    return null;
  }
};
